module.exports = __webpack_public_path__ + "static/media/icono_secciontrigo.0dd8a5fa.png";